import {Component} from 'react';
import Modal from 'react-bootstrap/Modal';

class StartUpDisplay extends Component {
    constructor(props) {
        super(props);
        this.state = {
            };
    }

    render() {
        let message = ""
        console.log("startUpDisplay being called")
        switch (this.props.messageType){
            case "rotateDevice":
                message = "🔄 Please rotate your device to landscape mode to play."
                break;
            case "tooNarrow":
                message = "Sorry, this device is too narrow for the game.  Please try the " +
                    "game on an iPad or lap-top.";
                break;
            default:
                message = "This is being called from unknown place."
                break;
        }
    return <> 
        <Modal show={true}  size="xl"  
          className="modal-startup" animation={false}>
            <div className="modal-startup very-very-large-text">
                {message}
            </div>
        
        </Modal>
    </>
    }
}

export default StartUpDisplay;